var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"min-height":"100vh !important"}},[_c('div',{staticClass:"font-weight-bold text-left custom-header-font mt-5 mb-2 text-center",staticStyle:{"font-size":"18px"}},[_vm._v("Labs")]),_c('div',{staticClass:"container"},[_c('LabProductChoice')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }